var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L15 7V13L10 10ZM15 22L8 26L1 22V15L8 19L15 15V22ZM1 7L6 10L1 13V7ZM9 10L14 13L9 16V10ZM7 16L2 13L7 10V16ZM14 4.57143L8 8L2 4.57143L8 1L14 4.57143ZM0 4.78392V23.2161L8 28L16 23.2161V4.78392L8 0L0 4.78392Z",
    fill: "#13B5EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXph);
export default __webpack_public_path__ + "static/media/xph.1ed78d333ac201a1e65f0fbb26dc9952.svg";
export { ForwardRef as ReactComponent };